import axios from "../axios-auth";
import orginal_axios from "axios";

export const productService = {
  getProductList,
  getAllProductList,
  saveProduct,
  getProductDetail,
  getProductsByStatus,
  getProductBySWC,
  getProductUnitByBarcode,
  getProductByCode,
  saveproductExcel,
  getProductExcelTemplate,
  getProductExcelExport,
  getProductByCodeAndPriceModel,
  getProductByNameOrCode,
};

function getProductList(searchParams, page, size, sortedBy, cancelToken) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.name2) {
    params["name2"] = searchParams.name2;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.brandName) {
    params["brandName"] = searchParams.brandName;
  }
  if (searchParams.categoryName) {
    params["categoryName"] = searchParams.categoryName;
  }
  if (searchParams.categoryId) {
    params["categoryId"] = searchParams.categoryId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.productGroupName) {
    params["productGroupName"] = searchParams.productGroupName;
  }
  if (searchParams.binIds) {
    params["binIds"] = searchParams.binIds.join();
  }
  if (searchParams.regionId) {
    params["regionId"] = searchParams.regionId;
  }
  if (searchParams.pricemodelId) {
    params["pricemodelId"] = searchParams.pricemodelId;
  }
  if (searchParams.isPurchase) {
    params["isPurchase"] = searchParams.isPurchase;
  }
  if (searchParams.isSale) {
    params["isSale"] = searchParams.isSale;
  }
  if (searchParams.productType) {
    params["productType"] = searchParams.productType;
  }
  if (searchParams.stockWarehouseId) {
    params["stockWarehouseId"] = searchParams.stockWarehouseId;
  }
  if (searchParams.stockBinId) {
    params["stockBinId"] = searchParams.stockBinId;
  }

  return axios.get("/auth/products", { params, cancelToken });
}

function getAllProductList(searchParams) {
  let params = {};

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.name2) {
    params["name2"] = searchParams.name2;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.brandName) {
    params["brandName"] = searchParams.brandName;
  }
  if (searchParams.categoryName) {
    params["categoryName"] = searchParams.categoryName;
  }
  if (searchParams.categoryId) {
    params["categoryId"] = searchParams.categoryId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.productGroupName) {
    params["productGroupName"] = searchParams.productGroupName;
  }
  if (searchParams.binIds) {
    params["binIds"] = searchParams.binIds.join();
  }
  if (searchParams.productType) {
    params["productType"] = searchParams.productType;
  }

  return axios.get("/auth/products", { params });
}

function saveProduct(product) {
  if (!product.id) {
    // new product
    return axios.post("/auth/product", product);
  } else {
    // edit
    return axios.put("/auth/product", product);
  }
}

function getProductDetail(id) {
  return axios.get("/auth/product/" + id);
}

function getProductsByStatus(status) {
  return axios.get("/auth/products-by-status/" + status);
}

function getProductBySWC(status, warehouseId, categoryId) {
  let params = {};

  if (status) {
    params["status"] = status;
  }

  if (warehouseId) {
    params["warehouseId"] = warehouseId;
  }

  if (categoryId) {
    params["categoryId"] = categoryId;
  }

  return axios.get("/auth/products", { params })
}

function getProductUnitByBarcode(searchParams) {
  let params = {};

  if (searchParams.barcode) {
    params["barcode"] = searchParams.barcode;
  }
  if (searchParams.pricemodelId) {
    params["pricemodelId"] = searchParams.pricemodelId;
  }
  if (searchParams.binId) {
    params["binId"] = searchParams.binId;
  }
  if (searchParams.isPurchase) {
    params["isPurchase"] = searchParams.isPurchase;
  }
  if (searchParams.isSale) {
    params["isSale"] = searchParams.isSale;
  }
  return axios.post("/auth/product-unit-by-barcode", params);
}

function getProductByCode(code, isSale) {
  let params = {};

  if (code) {
    params["code"] = code;
  }
  if (isSale) {
    params["isSale"] = isSale;
  }

  return axios.get("/auth/product-by-code", { params });
}

function getProductByCodeAndPriceModel(code, pricemodelId, binId, isPurchase, isSale, qcNo, batchNo) {
  let params = {};

  if (code) {
    params["code"] = code;
  }
  if (pricemodelId) {
    params["pricemodelId"] = pricemodelId;
  }
  if (binId) {
    params["binId"] = binId;
  }
  if (isPurchase) {
    params["isPurchase"] = isPurchase;
  }
  if (isSale) {
    params["isSale"] = isSale;
  }
  if (qcNo) {
    params["qcNo"] = qcNo;
  }
  if (batchNo) {
    params["batchNo"] = batchNo;
  }
  return axios.get("/auth/product-by-code", { params });
}

function getProductExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/product-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function saveproductExcel(file) {
  return axios.post('/auth/product-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function getProductExcelExport(searchParams) {
  let params = {};

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.name2) {
    params["name2"] = searchParams.name2;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.brandName) {
    params["brandName"] = searchParams.brandName;
  }
  if (searchParams.categoryName) {
    params["categoryName"] = searchParams.categoryName;
  }
  if (searchParams.categoryId) {
    params["categoryId"] = searchParams.categoryId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.productGroupName) {
    params["productGroupName"] = searchParams.productGroupName;
  }
  if (searchParams.binIds) {
    params["binIds"] = searchParams.binIds.join();
  }
  if (searchParams.productType) {
    params["productType"] = searchParams.productType;
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/product-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getProductByNameOrCode(searchParams) {
  let params = {};

  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.name) {
    params["name"] = searchParams.name;
  }

  return axios.get("/auth/product-by-name-code", { params });
}
